import { scope, type } from 'arktype';

import { BeneficiaryType } from '@/types/customer';

export const addCustomerSchema = scope({
  Business: {
    customerType: type.enumerated(BeneficiaryType.business),
    businessName: type('string>0').configure({ message: 'VALIDATION_REQUIRED' }),
  },
  Individual: {
    customerType: type.enumerated(BeneficiaryType.individual),
    firstName: type('string>0').configure({ message: 'VALIDATION_REQUIRED' }),
    lastName: type('string>0').configure({ message: 'VALIDATION_REQUIRED' }),
  },
}).type('Business | Individual');

export type AddCustomerFormData = typeof addCustomerSchema.infer;
